// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//   React context
import {useMaterialUIController} from "context";
import {Grid, Typography} from "@mui/material";
import dayjs from "dayjs";
import {formatDate} from "constants/ApplicationConstants";
import properties from "constants/ApplicationConstants";

function Bill_dependents({dependents, noGutter}) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  return (
    <MDBox pt={1} pb={0} px={2}>
      <MDBox pt={3} px={2}>
        <Typography variant="h6" fontWeight="medium" fontFamily={properties.fontFamily}>
          Dependent
        </Typography>
      </MDBox>
      <MDBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        bgColor={darkMode ? "transparent" : "grey-100"}
        borderRadius="lg"
        p={1}
        mb={noGutter ? 0 : 1}
        mt={1}
      >
        <MDBox width="100%" display="flex" flexDirection="column">
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={3}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Name &nbsp;
                </Typography>
              </MDBox>
            </Grid>
            <Grid item xs={12} sm={3}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Relation &nbsp;
                </Typography>
              </MDBox>
            </Grid>
            <Grid item xs={12} sm={3}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Birth Date &nbsp;
                </Typography>
              </MDBox>
            </Grid>
            <Grid item xs={12} sm={3}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Address &nbsp;
                </Typography>
              </MDBox>
            </Grid>
          </Grid>
          {dependents && dependents.length > 0
            ? dependents.map((dependents, index) => (
                <Grid container spacing={2} mb={2}>
                  <Grid item xs={12} sm={3}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {dependents ? dependents.dependentName : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        textTransform="capitalize"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {dependents ? dependents.dependentRelation : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {dependents ? formatDate(dependents.birthDate) : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        mr={2}
                        fontFamily={properties.fontFamily}
                      >
                        {dependents ? dependents.permanentAddress : "NA"}
                      </Typography>
                    </MDBox>
                  </Grid>
                </Grid>
              ))
            : []}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

Bill_dependents.defaultProps = {
  noGutter: false
};

Bill_dependents.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  noGutter: PropTypes.bool
};

export default Bill_dependents;
